export default "__VITE_ASSET__oIdEOCzS__"